"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Widget_1 = require("../tools/Widget");
var jquery_1 = __importDefault(require("jquery"));
var CloseableCardHandler = (function (_super) {
    __extends(CloseableCardHandler, _super);
    function CloseableCardHandler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CloseableCardHandler.prototype.init = function () {
        this.el.on('click', 'h1', jquery_1.default.proxy(this.toggle, this));
    };
    CloseableCardHandler.prototype.toggle = function () {
        this.el.toggleClass('open');
    };
    return CloseableCardHandler;
}(Widget_1.Widget));
exports.CloseableCardHandler = CloseableCardHandler;
